import { useQuery } from '@tanstack/react-query'
import { getService } from '@/api/requests/service'

export function useServiceDetail(spaceId: string, serviceId: string) {
  const {
    data: service,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['service', spaceId, serviceId],
    queryFn: () => getService(spaceId, serviceId),
    enabled: !!spaceId && !!serviceId,
  })

  return {
    service,
    isLoading,
    error,
  }
}
